import { createContext, Dispatch, SetStateAction } from 'react';
import { ISearchParams } from './searchParams';

export enum Modal {
  NULL = 'NUL',
  ARRIVALS = 'ARV',
  ARRIVALS_EVERYWHERE = 'ARV_E',
  DEPARTURES = 'DPT',
  DEPARTURES_EVERYWHERE = 'DPT_E',
  CALENDAR = 'CAL',
  FARE_CHART = 'CHT',
  RECOMMEND = 'RCM',
  CARD_FARE_TYPES = 'CFT',
  SIMILAR = 'SIM',
  NOTIFICATION = 'NTF',
  POLICY = 'POL',
}

export enum ModalPosition {
  MAIN = 'mai',
  LIST = 'lst',
  DETAIL = 'dtl',
  RECOMMEND = 'rcm',
}

export interface IModal {
  type: Modal;
  position: ModalPosition;
  payload?: { [key: string]: any };
}
export const ModalFuncContext = createContext<
  Dispatch<SetStateAction<IModal>> | Function
>(() => {});

export enum ModalTypes {
  autocomplete = 'autocomplete',
  detail = 'detail',
  search = 'search',
  similar = 'similar',
  notification = 'notification',
  policy = 'policy',
}

export interface IModalComponent {
  modalInfo: IModal;
  searchParams: ISearchParams;
  setModal: Dispatch<SetStateAction<IModal>> | Function;
  isSearchBoxFixed?: boolean;
}
